import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import { capitalizeCityName } from '../routes/seoRoutes';

export const Footer: React.FC = () => {
  // Use optional chaining to handle cases where context might not be available
  const { city } = useAppContext() || {};
  const capitalizedCity = city ? capitalizeCityName(city) : 'Reggio Emilia';
  
  return (
    <footer className="relative text-white bg-gray-900">
      {/* Background Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(/img/overlay2.png)',
          opacity: 0.1
        }}
      />

      <div className="container relative z-10 px-4 pt-20 pb-10 mx-auto">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">      
            <img src="/img/logo-bianco.png" alt="Vendi la Tua Auto Adelaide" className="h-12 mb-4" />
            <p className="mb-4 text-gray-400">
              {city 
                ? `Siamo specializzati nell'acquisto di veicoli usati a ${capitalizedCity} e in tutta Italia con pagamento immediato e massima professionalità. Ottieni il miglior valore per la tua auto oggi!`
                : 'Siamo specializzati nell\'acquisto di veicoli usati in tutta Italia con pagamento immediato e massima professionalità. Ottieni il miglior valore per la tua auto oggi!'
              }
            </p>
            <div className="mt-6">
              <h5 className="mb-3 text-lg font-bold">Aree di Servizio</h5>
              <p className="text-gray-400">
              Bologna, Modena, Reggio Emilia, Parma, Piacenza, Ferrara, Rimini, Cesena, Forlì, Ravenna, Milano, Monza, Brescia, Bergamo, Como, Lecco, Varese, Pavia, Lodi, Cremona, Mantova, Sesto San Giovanni, Cinisello Balsamo, Legnano, Rho, Busto Arsizio, Gallarate
              {/* [ */}
  {/* "bologna", */}
  {/* "modena", */}
  {/* "reggio emilia", */}
  {/* "parma", */}
  {/* "piacenza", */}
  {/* "ferrara", */}
  {/* "rimini", */}
  {/* "cesena", */}
  {/* "forlì", */}
  {/* "ravennna", */}
  {/* "milano", */}
  {/* "monza", */}
  {/* "brescia", */}
  {/* "bergamo", */}
  {/* "como", */}
  {/* "lecco", */}
  {/* "varese", */}
  {/* "pavia", */}
  {/* "lodi", */}
  {/* "cremona", */}
  {/* "mantova", */}
  {/* "sesto san giovanni", */}
  {/* "cinisello balsamo", */}
  {/* "legnano", */}
  {/* "rho", */}
  {/* "busto arsizio", */}
  {/* "gallarate" */}
{/* ] */}
{/*  */}
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="mb-4 text-lg font-bold">Link Rapidi</h5>
            <ul className="space-y-2">
              <li><a href="/" className="hover:text-blue-400">Home</a></li>
              <li><a href="/#come-funziona" className="hover:text-blue-400">Come Funziona</a></li>
              <li><a href="/#servizi" className="hover:text-blue-400">Servizi</a></li>
              <li><a href="/#marche-e-veicoli" className="hover:text-blue-400">Marche e Veicoli</a></li>
              <li><a href="/#faq" className="hover:text-blue-400">FAQ</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h5 className="mb-4 text-lg font-bold">Contattaci</h5>
            <ul className="space-y-4">
              <li className="flex items-center">
                <MapPin className="w-5 h-5 mr-2" />
                {capitalizedCity}
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 mr-2" />
                <a href="tel:+61451326175" className="hover:text-blue-400">+379 1281345</a>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 mr-2" />
                <a href="mailto:info@valutaauto.it" className="hover:text-blue-400">
                  valuta@valutaauto.it
                </a>
              </li>
            </ul>
            <div className="flex mt-6 space-x-4">
              <a href="#" className="hover:text-blue-400" aria-label="Follow us on Facebook">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="#" className="hover:text-blue-400" aria-label="Follow us on Instagram">
                <Instagram className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>

      

        {/* Copyright */}
        <div className="pt-8 mt-8 text-center border-t border-gray-800">
          <p className="text-gray-400">
            © {new Date().getFullYear()} Valuta Auto.it Tutti i diritti riservati
          </p>
        </div>
      </div>
    </footer>
  );
};